import type { LLVideoElement } from '../../types';

export function VideoElement({ element }: { element: LLVideoElement }) {
  return (
    <video
      src={element.videoUrl}
      controls
      className="rounded-md border max-w-full h-auto"
      preload="metadata"
    />
  );
}
